import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Logger } from '../utils/Logger';
import { ChromeStorage, LocalStorage } from '..';
var logger = new Logger('STORAGE');
/**
 * Get a supported storage on this platform
 */

export var getStorage = function getStorage() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return ChromeStorage.isSupported();

          case 2:
            if (!_context.sent) {
              _context.next = 7;
              break;
            }

            logger.log('getStorage', 'USING CHROME STORAGE');
            return _context.abrupt("return", new ChromeStorage());

          case 7:
            _context.next = 9;
            return LocalStorage.isSupported();

          case 9:
            if (!_context.sent) {
              _context.next = 14;
              break;
            }

            logger.log('getStorage', 'USING LOCAL STORAGE');
            return _context.abrupt("return", new LocalStorage());

          case 14:
            throw new Error('no storage type supported');

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};